/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Wed Jan 22 2025
 **/

import { useRef } from "react";

import { useEventHandlers } from "@rfice/eventhandler";
import { IExpandWhiteboardHandlers } from "@/types/types";

export default function useExpandEventHandler() {
	const handlersRef = useRef<Partial<IExpandWhiteboardHandlers>>({});

	// event로 whiteboard 정보가 업데이트 되면 rfice에 필요한 데이터 전달
	useEventHandlers(
		{
			onShrinkButtonClose: () => {
				handlersRef.current.onWindowClose?.();
				handlersRef.current = {};
			},
			onDrawingToolbarImageClicked: () => {
				handlersRef.current.onImageClicked?.();
			}
		},
		[handlersRef]
	);

	return {
		add: (handlers: IExpandWhiteboardHandlers) => {
			handlersRef.current = { ...handlers };
		}
	};
}
